// isMobile
!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!=typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!=typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"==typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=r:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=s():"function"==typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);
//https://github.com/tristen/hoverintent
!function(e,t){if("function"==typeof define&&define.amd)define("hoverintent",["module"],t);else if("undefined"!=typeof exports)t(module);else{var n={exports:{}};t(n),e.hoverintent=n.exports}}(this,function(e){"use strict";var t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};e.exports=function(e,n,o){function i(e,t){return y&&(y=clearTimeout(y)),b=0,p?void 0:o.call(e,t)}function r(e){m=e.clientX,d=e.clientY}function u(e,t){if(y&&(y=clearTimeout(y)),Math.abs(h-m)+Math.abs(E-d)<x.sensitivity)return b=1,p?void 0:n.call(e,t);h=m,E=d,y=setTimeout(function(){u(e,t)},x.interval)}function s(t){return L=!0,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1!==b&&(h=t.clientX,E=t.clientY,e.addEventListener("mousemove",r,!1),y=setTimeout(function(){u(e,t)},x.interval)),this}function c(t){return L=!1,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1===b&&(y=setTimeout(function(){i(e,t)},x.timeout)),this}function v(t){L||(p=!0,n.call(e,t))}function a(t){!L&&p&&(p=!1,o.call(e,t))}function f(){e.addEventListener("focus",v,!1),e.addEventListener("blur",a,!1)}function l(){e.removeEventListener("focus",v,!1),e.removeEventListener("blur",a,!1)}var m,d,h,E,L=!1,p=!1,T={},b=0,y=0,x={sensitivity:7,interval:100,timeout:0,handleFocus:!1};return T.options=function(e){var n=e.handleFocus!==x.handleFocus;return x=t({},x,e),n&&(x.handleFocus?f():l()),T},T.remove=function(){e&&(e.removeEventListener("mouseover",s,!1),e.removeEventListener("mouseout",c,!1),l())},e&&(e.addEventListener("mouseover",s,!1),e.addEventListener("mouseout",c,!1)),T}});
/*! js-cookie v3.0.0-rc.4 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,r=e.Cookies=t();r.noConflict=function(){return e.Cookies=n,r}}())}(this,function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}var t={read:function(e){return e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}};return function n(r,o){function i(t,n,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape),n=r.write(n,t);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n+c}}return Object.create({set:i,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],o={},i=0;i<n.length;i++){var c=n[i].split("="),u=c.slice(1).join("=");'"'===u[0]&&(u=u.slice(1,-1));try{var f=t.read(c[0]);if(o[f]=r.read(u,f),e===f)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){i(t,"",e({},n,{expires:-1}))},withAttributes:function(t){return n(this.converter,e({},this.attributes,t))},withConverter:function(t){return n(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(r)}})}(t,{path:"/"})});

function slideToggle(t,e,o){0===t.clientHeight?slideJ(t,e,o,!0):slideJ(t,e,o)}function slideUp(t,e,o){slideJ(t,e,o)}function slideDown(t,e,o){slideJ(t,e,o,!0)}function slideJ(t,e,o,i){void 0===e&&(e=400),void 0===i&&(i=!1),t.style.overflow="hidden",i&&(t.style.display="block");var p,l=window.getComputedStyle(t),n=parseFloat(l.getPropertyValue("height")),a=parseFloat(l.getPropertyValue("padding-top")),s=parseFloat(l.getPropertyValue("padding-bottom")),r=parseFloat(l.getPropertyValue("margin-top")),d=parseFloat(l.getPropertyValue("margin-bottom")),g=n/e,y=a/e,m=s/e,u=r/e,h=d/e;window.requestAnimationFrame(function l(x){void 0===p&&(p=x);var f=x-p;i?(t.style.height=g*f+"px",t.style.paddingTop=y*f+"px",t.style.paddingBottom=m*f+"px",t.style.marginTop=u*f+"px",t.style.marginBottom=h*f+"px"):(t.style.height=n-g*f+"px",t.style.paddingTop=a-y*f+"px",t.style.paddingBottom=s-m*f+"px",t.style.marginTop=r-u*f+"px",t.style.marginBottom=d-h*f+"px"),f>=e?(t.style.height="",t.style.paddingTop="",t.style.paddingBottom="",t.style.marginTop="",t.style.marginBottom="",t.style.overflow="",i||(t.style.display="none"),"function"==typeof o&&o()):window.requestAnimationFrame(l)})}

$s = new function() {
  this.throttle = function (callback, limit) {
    var waiting = false;
    var callAfterWaiting = null;
    return function () {
      if (!waiting) { 
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
          if (callAfterWaiting) {
            callAfterWaiting();
            callAfterWaiting = null;
          }
        }, limit);
      } else {
        callAfterWaiting = function() {
          callback.apply(this, arguments);
        }
      }
    }
  }

  this.getFocusableElements = function(container) {
    return Array.from(container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    ));
  }

  this.scrollToElement = function(selectorOrElement, offsetTop, behavior) {
    var headerOffset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'));
    var element = typeof(selectorOrElement)=='string' ? document.querySelector(selectorOrElement) : selectorOrElement;
    var paddingTop = false;
    if (element.closest('.shopify-section') && element.closest('.shopify-section').querySelector('.padding-top')) {
      paddingTop = true;
    }
    var defaultOffset = 0; //50;
    var customOffsetText = getComputedStyle(element).getPropertyValue('--custom-scroll-offset') || '0';
    var customOffset = customOffsetText.indexOf('rem')>-1 ? $s.calcRemToPx(customOffsetText) : (customOffsetText.indexOf('em')>-1 ? $s.calcEmToPx(element, customOffsetText) : parseFloat(customOffsetText) );
    var scrollAmount = Math.round(element.getBoundingClientRect().top  - (customOffset || offsetTop || (paddingTop ? 0 : defaultOffset)));
    if (scrollAmount > 0) {
      try {
        var headerContent = document.querySelector('#header .header-content');
        if (($s.media.isLarge && !headerContent.classList.contains('desktop-mode--sticky'))
          || (!$s.media.isLarge && !headerContent.classList.contains('mobile-mode--sticky')) ) {
          if (scrollAmount - headerOffset == 0) {
            //already in location, avoid drop header collapse;
            return;
          }
          headerOffset = 0;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    window.scrollBy({
      left: 0,
      top: scrollAmount - headerOffset,
      behavior: (behavior || 'smooth')
    })
  }

  var trapFocusStack = [];
  this.trapFocus = function(container, elementToFocus=false) {
    var trapItem = {
      beforeFocus: document.activeElement,
      container: container,
      handlerFocus: function(evt){
        if(trapFocusStack.length==trapIndex) {
          if(container !== evt.target && !container.contains(evt.target)) {
            container.focus();
          }
        }
      },
      handlerKeyDown: function(evt){
        if(evt.code.toUpperCase()!=='TAB') return; // If not TAB key

        var elements = $s.getFocusableElements(container);
        var first = elements[0];
        var last = elements[elements.length - 1];

        if(evt.target===last && !evt.shiftKey) {
          evt.preventDefault();
          first.focus();
        }
        if((evt.target===container || evt.target===first) && evt.shiftKey) {
          evt.preventDefault();
          last.focus();
        }
      }
    }
    trapFocusStack.push(trapItem);
    var trapIndex = trapFocusStack.length;
    if(!elementToFocus) {
      elementToFocus = container;
    }
    container.setAttribute('tabindex', '-1');
    elementToFocus.focus();

    container.addEventListener('keydown', trapItem.handlerKeyDown);
    document.addEventListener('focusin', trapItem.handlerFocus);
  }

  this.removeTrapFocus = function() {
    var lastItem = trapFocusStack.pop();
    if(lastItem) {
      if(lastItem.beforeFocus) {
        lastItem.beforeFocus.focus();
      }
      if(lastItem.container) {
        lastItem.container.removeAttribute('tabindex');
        lastItem.container.removeEventListener('keydown', lastItem.handlerKeyDown);
      }
      document.removeEventListener('focusin', lastItem.handlerFocus);
    }
  }

  window.modal = null;
  this.openModal = function(content, css, options={}) {
    var defaults = {
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [css],
      onOpen: function() {
        $s.trapFocus(this.modal);
        return true;
      },
      onClose: function() {
        $s.removeTrapFocus();
        if (options.close)
          options.close();
        return true;
      }
    };
    modal = new tingle.modal(Object.assign(defaults, options));
    modal.setContent(content);
    modal.open();
    return modal;
  }

  this.closeModal = function() {
    if(window.modal && window.modal.modal) {
      window.modal.close();
    }
  }

  this.handleize = function(str) {
    return str.toLowerCase().replace(/\'|\"/g, "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, ""); 
  }

  this.imgUrlFilter = function(url, filter) {
    var position = url.split('?')[0].lastIndexOf('.');
    url = url.substring(0, position) + '_' + filter + url.substring(position);
    return url;
  }

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L) {
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length < L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.formatMoney = function(cents, format) {
    if(typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || window.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if(isNaN(number) || number == null) {return 0;}

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }
    
    var m = formatString.match(placeholderRegex);
    if (m && m.length > 0) {
      switch (m) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    } else {
      return '$' + formatWithDelimiters(cents, 2).replace('.00', '');
    }
    
    
  }

  this.matchHeight = function (elements) {
    var height = 0;
    elements.forEach(function(e, ix) {
      e.style.minHeight = '';
    });
    elements.forEach(function(e, ix) {
      height = Math.max(height, e.offsetHeight);
    });
    elements.forEach(function(e, ix) {
      e.style.minHeight = height + 'px';
    });
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    if(images.length>0) {
      images.forEach(function(obj){
        var img = new Image();
        img.onload = loadFunction;
        img.onerror = loadFunction;
        img.src = obj.getAttribute('src');
      });
    } else {
      callback();
    }
  }

  this.pauseAllMedia = function(container) {
    container = container || document;
    container.querySelectorAll('.js-youtube, .js-vimeo, video, product-model').forEach((media) => {
      $s.pauseMedia(media)
    });
  }

  this.pauseMedia = function(media) {
    if(media) {
      if(media.classList.contains('.js-youtube')) {
        media.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        return;
      }
      if(media.classList.contains('.js-vimeo')) {
        media.contentWindow.postMessage('{"method":"pause"}', '*');
        return;
      }
      if(media.tagName.toLowerCase()=='video') {
        media.pause();
        return;
      }
      if(media.tagName.toLowerCase()=='product-model') {
        //media.modelViewerUI?.pause() The ? throws an error in Ipad 6th Gen.
        return;
      }
    }
  }

  this.playMedia = function(media) {
    if(media) {
      if(media.classList.contains('.js-youtube')) {
        media.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        return;
      }
      if(media.classList.contains('.js-vimeo')) {
        media.contentWindow.postMessage('{"method":"play"}', '*');
        return;
      }
      if(media.tagName.toLowerCase()=='video') {
        media.play();
        return;
      }
      if(media.tagName.toLowerCase()=='product-model') {
        //media.modelViewerUI?.play() The ? throws an error in Ipad 6th Gen.
        return;
      }
    }
  }

  this.media = new function() {
    var self = this;
    var mqS = window.matchMedia("(max-width: 600px)");
    var mqM = window.matchMedia("(max-width: 900px)");
    var mq12 = window.matchMedia("(max-width: 1250px)");
    var mqO = window.matchMedia("(orientation: landscape)");
    var tId = 0;
    function updateMedia() {
      self.isLarge = !mqM.matches;
      self.isMediumUp = !mqS.matches;
      self.isMedium = mqM.matches && !mqS.matches;
      self.isMediumDown = mqM.matches;
      self.isSmall = mqS.matches;
      self.isLandscape = mqO.matches;
      self.is1250Down = mq12.matches;
    }
    function handler() {
      clearTimeout(tId);
      tId = setTimeout(function() {
        updateMedia();
        window.dispatchEvent(new Event('mediaChange'));
      }, 1);
    }
    updateMedia();
    mqS.addListener(handler);
    mqM.addListener(handler);
    mqO.addListener(handler);
    return this;
  }

  this.isVisible = function(element){
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  this.isInViewport = function(element){
    const {top, bottom} = element.getBoundingClientRect();
    const vHeight = (window.innerHeight || document.documentElement.clientHeight);
    return ((top>0 || bottom>0) && top<vHeight);
  }

  this.escapeDomAttribute = function(value) {
    return value.replaceAll('"', '&quot;');
  }

  function slideTransitionEnd(evt) {
    if (evt.propertyName=='max-height') {
      var panel = evt.target;
      if (panel.style.maxHeight == '0px') {
        panel.style.visibility = 'hidden';
        panel.style.overflow = 'hidden';
      }else{
        panel.style.maxHeight = 'none';
        panel.style.overflow = 'visible';
      }
    }
  }

  this.expand = function(panels, options) {
    var settings = {'duration': 400, 'effect': 'ease-out'}
    if (options) {
      $s.extend(settings, options);
    }
    if (typeof(panels.length)=='undefined') {
      panels = [panels];
    }
    panels.forEach(function(panel) {
      panel.style.visibility = 'visible';
      panel.removeEventListener('transitionend', slideTransitionEnd);
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height '+settings.duration+'ms '+settings.effect;
      var height = panel.scrollHeight + 'px';
      panel.style.maxHeight = height;
      panel.addEventListener('transitionend', slideTransitionEnd);
    });
  }

  this.collapse = function(panels, options) {
    var settings = {'duration': 400, 'effect': 'ease-out'}
    if (options) {
      $s.extend(settings, options);
    }
    if (typeof(panels.length)=='undefined') {
      panels = [panels];
    }
    panels.forEach(function(panel) {
      panel.removeEventListener('transitionend', slideTransitionEnd);
      panel.style.transition = 'max-height '+settings.duration+'ms '+settings.effect;
      var height = panel.scrollHeight + "px";
      panel.style.maxHeight = height;
      setTimeout(()=>{
        panel.style.overflow = 'hidden';
        panel.style.maxHeight = '0px';
        panel.addEventListener('transitionend', slideTransitionEnd);
      },100) /* workaround to instant collapse*/
    });
  }

  this.toggle = function(panels, options) {
    if (typeof(panels.length)=='undefined') {
      panel = [panels];
    }
    panels.forEach(function(panel) {
      var style = window.getComputedStyle(panel);
      if (style.maxHeight=='0px' || style.display=='none') {
        $s.expand([panel], options);
      } else {
        $s.collapse([panel], options);
      }
    });
  }

  var body = document.querySelector('body');
  var html = document.querySelector('html');
  var overlay = document.getElementById('overlay');
  var loadingOverlay = document.getElementById('loading-overlay');

  this.hideScroll = function() {
    //body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
  }

  this.showScroll = function() {
    //body.style.overflow = '';
    html.style.overflow = '';
  }

  this.showOverlay = function() {
    html.classList.add('show-overlay');
  }

  this.hideOverlay = function() {
    html.classList.remove('show-overlay');
  }

  this.showLoadingOverlay = function() {
    html.classList.add('show-loading-overlay');
    $s.trapFocus(loadingOverlay);
  }
  this.hideLoadingOverlay = function() {
    html.classList.remove('show-loading-overlay');
    $s.removeTrapFocus();
  }
  this.addToCartSuccess = function(callback) {
    if (!document.querySelector('.ab-trigger-test').classList.contains('trigger-cart')) {
      if (window.SideCart) {
        window.SideCart.updateSideCart(false);
      }
      $s.hideLoadingOverlay();
      return;
    }

    if(window.SideCart){
      window.SideCart.updateSideCart(true);
    } else {
      location = '/cart'
    }
  }

  this.updateCartBadge = function() {
    
    $s.getJson({
        "url": '/cart.js',
        "success": (data) => {
            document.querySelectorAll('.cart-count').forEach((count) => {
              count.innerHTML = data.items ? data.items.reduce((t, i) => t + i.quantity, 0) : 0;
            })
        }
    });

  }

  this.addToCartFail = function(msg) {
    $s.hideLoadingOverlay();
  	$s.openModal('<div class="error-itemincart">'+msg+'</div>', 'message');
  }
  this.cartSynchronize = async function(currentCart) {

    //set a fixed value on data that change on each refresh
    currentCart.items.forEach((a) => {
      if (a.line_level_discount_allocations) {
        a.line_level_discount_allocations.forEach((b) => {
            if (b.discount_application) {
              b.discount_application.key = 'fix value';
              b.discount_application.created_at = 'fix value';
            }
        });
      }
    });

    this.carthash = await $s.digestMessage(JSON.stringify(currentCart));
    if (!this.initialized) {
      this.initialized = true;
      window.addEventListener('focus', () => {
        var cookieCartHash = Cookies.get('carthash');
        if (cookieCartHash!=this.carthash) {
          if (window.SideCart) {
            window.SideCart.updateSideCart(window.SideCart.isOpen());
          } else if (window.CartPage) {
            window.CartPage.updateCart();
          }
        }
      });
    }
    var cookieCartHash = Cookies.get('carthash');
    if (cookieCartHash!=this.carthash) {
      Cookies.set('carthash', this.carthash);
    }
  }
  //hash Function
  this.digestMessage = async function(message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }
  this.dispatchEvent = function(target, eventName) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, false, true);
    target.dispatchEvent(event);    
  }
  this.checkout = function(elementTrigger, discountCode) {
    $s.showLoadingOverlay();
    $s.getJson({url: '/cart.json', success: function(data) {
      if (!discountCode && data.attributes && data.attributes['_discount_code']) {
        discountCode = data.attributes['_discount_code'];
      }
      data.items.forEach(function(item) {
        if(!discountCode && item.properties && item.properties._discount_code){
          discountCode = item.properties._discount_code;
        }
      })

      location = '/checkout' + (discountCode ? '?discount=' + discountCode : '');
    }});
  }
  /* deep merge */
  this.extend = function(target, source) {
    for (const key of Object.keys(source)) {
      if (source[key] instanceof Object) Object.assign(source[key], $s.extend(target[key], source[key]))
    }
    Object.assign(target || {}, source)
    return target;
  }

  this.updateDynamicContent = function(sourceContainer, newContentHtmlOrElement, customAreaSelectors) {
    var newContentElement;
    if (typeof(newContentHtmlOrElement)=='string') {
      var parser = new DOMParser();
      newContentElement = parser.parseFromString(newContentHtmlOrElement, 'text/html');
    } else {
      newContentElement = newContentHtmlOrElement;
    }
    let areasSelectors = [];
    if (customAreaSelectors) {
      areasSelectors = customAreaSelectors.split(',')
    } else {
      sourceContainer.querySelectorAll('[data-dynamic-content]').forEach(srcArea=>areasSelectors.push('[data-dynamic-content="'+srcArea.dataset.dynamicContent+'"]'));
    } 
    areasSelectors.forEach(selector=>{
      const srcArea = sourceContainer.querySelector(selector);
      srcArea.outerHTML = newContentElement.querySelector(selector).outerHTML;
    })

  }

  this.globalEval = function(textHtmlOrElement) {
    if (typeof(textHtmlOrElement)=="string") {
      var parser = new DOMParser();
      var doc = parser.parseFromString(textHtmlOrElement, 'text/html');
    } else {
      doc = textHtmlOrElement;
    }
    var scripts = doc.querySelectorAll('script');
    scripts.forEach(function(script) {
      if (script.src) {
        var d = document.createElement('script');
        for (var i= 0; i<script.attributes.length; i++) {
          d.setAttribute(script.attributes[i].name, script.attributes[i].value);
          document.head.appendChild(d).parentNode.removeChild(d);
        }
      } else {
        if(script.type!='application/json') {
          eval(script.innerHTML);
        }
      }
    })
  }


  this.ajax = function(options) {
    let _options = {
      "type": "get",
      "data": null
    }
    $s.extend(_options, options);
    var req = new XMLHttpRequest();
    let promise = new Promise(function(resolve, reject){
      req.open(_options.type, _options.url, true);
      req.onreadystatechange = function (aEvt) {
        if (req.readyState == 4) {
          if(req.status == 200)
            resolve(req);
          else
            reject(req);
        }
      };
      req.send(_options.data);  
    });
    promise.ajaxCall = req;
    return promise;
  }

  this.get = function(params) {
    return $s.fetch({...params, type: 'text'});
  }

  this.getJson = function(params) {
    return $s.fetch({...params, type: 'json'});
  }

  this.post = function(params) {
    params.type = params.type || 'json';
    if(params.data) {
      if(typeof params.data==='string') {
        params.headers = params.headers || {'Content-Type':'application/x-www-form-urlencoded'};
        params.body = params.data;
      } else {
        if(!(params.data instanceof FormData)) {
          params.headers = params.headers || {'Content-Type': 'application/json'};
          params.body = JSON.stringify(params.data);
        } else {
          params.body = params.data;
        }
      }
    }
    return $s.fetch({...params, method: 'POST'});
  }

  this.fetch = function(params) {
    const controller = new AbortController();
    const config = {
      method: params.method || 'GET',
      headers: params.headers,
      mode: params.mode || 'cors',
      body: params.body,
      signal: controller.signal
    };

    function parseResponse(text) {
      var data = text;
      if(params.type=='json') {
        try {
          data = JSON.parse(text);
        }catch(e) {
          data = {};
          console.error('parseResponse error, cannot JSON.parse: ', text);
        }
      }
      return data;
    }
    // this should be fetch(), please see comments on the first line of theme.liquid
    window.fetchNative(params.url, config)
      .then((response) => {
        response.text().then((text)=>{
          if(response.ok) {
            if(params.success) {
              params.success(parseResponse(text), response);
            }
          } else {
            if(params.error) {
              params.error(parseResponse(text), response);
            }
          }
        });
      })
      .catch((e) => {
        if(e.name!='AbortError') {
          if(params.error) {
            params.error(parseResponse(''));
          }
        }
      })
      .finally(() => {
        if(params.always) {
          params.always();
        }
      });
    return controller;
  }

  this.setHeaderSubmenus = function() {
    var hasDropDowns = document.querySelectorAll('.header-main-menu .has-dropdown:not(.submenu-initialized)');
    hasDropDowns.forEach(function(obj) {
      obj.classList.add('submenu-initialized');
      hoverintent(obj,
        function() {
          $s.expand([obj.querySelector('.submenu')]);
        }, function() {
          $s.collapse([obj.querySelector('.submenu')]);
        }
      ).options({timeout: 300});
      obj.querySelectorAll('.nav-1').forEach(function(obj){
        obj.addEventListener('keydown', function(e){
          if(e.which==32) { //Spacebar
            e.preventDefault();
            $s.toggle([obj.nextSibling]);
          }
          if(e.which==40) { //Arrow Down
            e.preventDefault();
            $s.expand([obj.nextSibling]);
          }
          if(e.which==38) { //Arrow Up
            e.preventDefault();
            $s.collapse([obj.nextSibling]);
          }
          if(obj.closest('.submenu')) {
            if(e.which==39) { //Arrow Right
              e.preventDefault();
              $s.expand([obj.nextSibling]);
            }
            if(e.which==37) { //Arrow Left
              e.preventDefault();
              $s.collapse([obj.nextSibling]);
            }
          }
        });
      });
    });
  }
  function setHeaderSearch() {
    var bar = document.getElementById('search-bar');
    if (bar) {
      var header = document.querySelector('.header-inner');
      header.appendChild(bar);
      var stateOpen = false;
      var button = header.querySelector('.trigger-search')
      var buttonClose = header.querySelector('#header .close-search-bar')
      function toggleSearchBar() {
        stateOpen = !stateOpen;
        if (stateOpen) {
          button.setAttribute('aria-expanded', 'true')
          bar.classList.remove('close');
          bar.classList.add('open');
          setTimeout(function() {
            bar.querySelector('[name="q"]').focus();
          }, 100);
        } else {
          button.setAttribute('aria-expanded', 'false')
          bar.querySelector('search-form').clearResults();
          bar.classList.remove('open');
          bar.classList.add('close');
        }
      }
      button.addEventListener('click', toggleSearchBar);
      if (buttonClose) {
        buttonClose.addEventListener('click', toggleSearchBar);
      }
    }
  }

  function loadSectionsAsync() {
    var mobileMenuLoaded = false;
    function loadMobileMenu() {
      if ($s.media.is1250Down) {
        if (!mobileMenuLoaded && !document.getElementById('shopify-section-mobile_menu')) {
          mobileMenuLoaded = true;
          window.removeEventListener('mediaChange', loadMobileMenu);
          $s.getJson({url: '/?sections=mobile_menu', success: function(data){
            if(data["mobile_menu"]) {
              var header = document.getElementById('header');
              header.insertAdjacentHTML("afterend", data["mobile_menu"]);
              $s.globalEval(data["mobile_menu"]);
            }
          }})
        }
      }
    }
    window.addEventListener('mediaChange', loadMobileMenu);
    loadMobileMenu();

    
    function loadSideCart() {
      document.querySelectorAll('.trigger-cart').forEach((element)=>{
        element.addEventListener('click', function(e){
          e.preventDefault();
          window.SideCart ? window.SideCart.showSideCart(true): false;
        })
      });

      $s.getJson({url: '/?sections=side_cart', success: function(data){
        if(data["side_cart"]) {
          var section = document.getElementById('shopify-section-side_cart');
          if (section)
            section.parentNode.removeChild(section);
          document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
          $s.globalEval(data["side_cart"]);
        }
      }});
    }
    if (location.pathname != '/cart') {
      loadSideCart();
    }
    

    function loadCookiesConsent() {
      $s.getJson({url: '/?sections=cookies_consent', success: function(data){
        if(data["cookies_consent"]) {
          document.body.insertAdjacentHTML("beforeend", data["cookies_consent"]);
          $s.globalEval(data["cookies_consent"]);
        }
      }})
    }
    if(Cookies.get('CookiesConsent')!='true') {
      loadCookiesConsent();
    }

    var megaMenus = [];
    var megaMenusParentLinks = [];megaMenus.push('mega_menu_5');
        megaMenusParentLinks.push('about-glow');
    var megaMenuLoaded = false;
    function loadMegaMenu() {
      if (!megaMenuLoaded && $s.media.isLarge) {
        megaMenuLoaded = true;
        megaMenusParentLinks.forEach(function(parentKey) {
          var existingSubmenu = document.querySelector('.header-main-menu [data-parent="'+ parentKey +'"] .submenu');
          if (existingSubmenu) {
            existingSubmenu.remove();
          }
        })
        window.removeEventListener('mediaChange', loadMegaMenu);
        $s.getJson({url: '/?sections='+megaMenus.join(','), success: function(data){
          megaMenus.forEach(function(item) {
            if (data[item]) {
              document.body.insertAdjacentHTML("beforeend", data[item]);
              $s.globalEval(data[item]);
            }
          });
        }});
      }
    }
    window.addEventListener('mediaChange', loadMegaMenu);
    loadMegaMenu();
    

    function loadDiscountCodeLink() {
      var url = new URL(location.href);
      var code = url.searchParams.get('gr_discount_code') || url.searchParams.get('discount_code');
      if(code){
        if (url.searchParams.get('gr_discount_code')) {
          url.searchParams.delete('gr_discount_code');
        }
        if (url.searchParams.get('discount_code')) {
          url.searchParams.delete('discount_code');
        }
        history.replaceState({},'', url.toString());
        $s.getJson({
          url: '/?sections=autoadd_products_discount_code', 
          success: function(data) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data["autoadd_products_discount_code"], 'text/html');
            var jsonString = doc.querySelector('div.json').innerHTML;
            var json = JSON.parse(jsonString);
            var popup = doc.querySelector('div.autoadd-popup');

            var itemsAdd = json.items.filter(item=>{
              return item.discount_code == code;
            });
            if (itemsAdd.length > 0) {
              $s.post({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  "items": itemsAdd,
                  "attributes": {
                    "_discount_code": code
                  }
                },
                dataType: 'json',
                success: function (data) {
                  var json = JSON.parse(data);
                  var productsList = popup.querySelector('.products-list');
                  var listHTML = json.items.map(x=>'<li><strong>' + x.quantity + 'x</strong> ' + x.title + '</li>').join('');
                  productsList.innerHTML = listHTML;
                  var modal = $s.openModal(popup, 'message',{closeMethods: []});
                  popup.querySelector('.btn.close').addEventListener('click', function() {
                    modal.close();
                    $s.addToCartSuccess();
                  });
                }
              });
            }
          }
        });
      }    
    }
    loadDiscountCodeLink();

  }

  function userIsTabbing() {
    window.addEventListener('keydown', function(e){
      if(e.keyCode===9) { // tab
        document.body.classList.add('user-is-tabbing');
      }
    });
    document.addEventListener("click", function(){
      document.body.classList.remove('user-is-tabbing');
    });
  }

  var cssVariables = [];
  this.setCssVariable = function(variable, value, context=':root') {
    let existingItem = cssVariables.find(x=>x.variable==variable && x.context==context);
    if(existingItem) {
      existingItem.value = value;
    } else {
      cssVariables.push({variable, value, context});
    }
    let cssVariablesElement = document.getElementById('css-variables');
    if(cssVariablesElement) {
      cssVariablesElement.remove();
    }
    var variables = '';
    cssVariables.map(x=>{return x.context}).filter((x,i,a)=>a.indexOf(x)==i).forEach((varContext)=>{
      variables += varContext + ' {';
      cssVariables.filter(x=>x.context==varContext).forEach((cssVariable)=>{
        variables += `--${cssVariable.variable}: ${cssVariable.value};`;
      });
      variables += '}';
    });
    document.head.insertAdjacentHTML("beforeend", `<style id="css-variables">${variables}</style>`);
  }

  this.init = function() {
    if(!isMobile.any) {
      document.body.classList.add('not-mobile'); 
    }
    userIsTabbing();
    loadSectionsAsync();
    this.setHeaderSubmenus();
    setHeaderSearch();
  }
}

window.$ = window.$ || document.querySelector;
$s.init();

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    $s.hideLoadingOverlay();
  }
}, false);

/** QUASI-GLOBAL COMPONENTS **/
/* components below are used in the page main html, not from other features loaded async */

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if(this.input.value == this.input.max) {
      this.querySelector("button.plus").classList.add("disabled")
    }

    this.input.addEventListener('change', (e)=> {
      const target = e.target;
      if (Number(target.value) > Number(this.input.max))
        target.value = this.input.max
      })
    
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if(event.currentTarget.classList.contains('plus')) {
      this.input.stepUp();
      var nextValue = this.input.value;
      if(nextValue >= this.input.max) {
        this.querySelector("button.plus").classList.add("disabled")
      }
    } else {
      this.input.stepDown();
      var nextValue = this.input.value;
      if(nextValue < this.input.max) {
        this.querySelector("button.plus").classList.remove("disabled")
      }
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }



}
customElements.define('quantity-input', QuantityInput);

class CartPropertyField extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('textarea');
    this.saveBtn = this.querySelector('.save-msg')
    this.clearBtn = this.querySelector('.clear-msg')
    this.saveBtn.addEventListener('click', this.onValueChange.bind(this));
    this.clearBtn.addEventListener('click', this.onValueChange.bind(this));
    //this.input.addEventListener('input', this.onValueChange.bind(this));
    //this.input.addEventListener('change', this.onValueChange.bind(this));

    this.saveDelay = 1000;
    this.saveTimeout = null;
    //TODO: this.preventUnload = !this.dataset.preventUnload;
    //TODO: this.preventSubmitClick = !this.dataset.preventSubmitClick;
    this.requestController = null;
    this.badge = document.createElement('div');
    this.badge.innerHTML = 'Saving';
    this.badge.classList.add('badge');
    this.appendChild(this.badge);
    this.lastValueSent = null;
    this.closeWindow(this.parentNode.querySelector('.close-toogle'), this.closest('.gift-msg-wrapper'));
    this.openWindowIfMsg(this);
  }

  onValueChange(event) {
    
    clearTimeout(this.saveTimeout);
    var self = this;
    var buttonOption = event.target.dataset.validate;

    if (buttonOption == 0) {
      self.querySelector('textarea').value = '';
      $s.collapse([self.closest('.gift-msg-wrapper')])
    } 
    
    this.saveTimeout = setTimeout(function() {      
      if (self.lastValueSent == self.input.value && buttonOption) {
        return;
      }
      self.lastValueSent = self.input.value;
      var data = self.input.name +'='+ encodeURIComponent(self.input.value);

      //TODO: lock submitClick and unload
      
      self.badge.classList.add('show');
      if (self.requestController) {
        self.requestController.abort();
      }
      self.requestController = $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
        },
        error: function(response) {
          var response = JSON.parse(jqXHR.responseText);
          $s.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');          
        },
        always: function() {
          self.requestController = null;
          //TODO: unlock submit and unload
          self.badge.classList.remove('show');
        }
      });
    }, event.type=='change' ? 1 : this.saveDelay);
  }

  openWindowIfMsg(selector){
    var textarea = selector.querySelector('textarea');
    if (textarea.innerHTML) {
      $s.expand([selector.closest('.gift-msg-wrapper')])
    } else {
      $s.collapse([selector.closest('.gift-msg-wrapper')])
    }
  }


  closeWindow(trigger, target){
    trigger.addEventListener('click', function(){
      $s.collapse([target])
    })
  }

}
customElements.define('cart-property-field', CartPropertyField);class CartItemEdit extends HTMLElement {
  constructor() {
    super();
    this.key = this.closest('[data-key]').dataset.key;
    this.input = this.querySelector('select');
    this.input.addEventListener('change', this.onChange.bind(this));
    if (this.input.options.length < 2) {
      this.style.display = 'none';
    }

  }

  async onChange(event) {

    const newVariantId = this.input.value;
    const self = this;
    self.input.setAttribute('disabled', true);
    $s.showLoadingOverlay();
    let cart = await $s.getJson({url:'/cart.js'});
    const item = cart.items.find(item=>item.key==this.key);

    if (item) {
      const newItem = await $s.post({
        type: 'POST',
        url: routes.cart_url + '/add.js',
        data: {
          "id": newVariantId, 
          "quantity": item.quantity, 
          ...(item.properties ? {"properties": item.properties} : {}), 
          ...(item.selling_plan_allocation ? {"selling_plan": item.selling_plan_allocation.selling_plan.id} : {})
        },
        dataType: 'json'
      })

      cart = await $s.post({
        type: 'POST',
        url: routes.cart_url + '/change.js',
        data: {"id": this.key, "quantity": 0},
        dataType: 'json'
      })

      var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);
    }

    if(window.SideCart){
      window.SideCart.updateSideCart(true)
    } else if (window.CartPage) {
      window.CartPage.updateCart();
    } else {
      location = routes.cart_url;
    }

  }
}
customElements.define('cart-item-edit', CartItemEdit);class CartDiscountCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.button = this.querySelector('button');

    this.button.addEventListener('click', this.onSubmit.bind(this));
    this.input.addEventListener('keypress', this.onInputKeyPress.bind(this));
  }

  onInputKeyPress(event) {
    if (event.keyCode==13) {
      this.onSubmit();
    }
  }

  onSubmit() {
    var self = this;
    self.button.setAttribute('disabled', true);
    $s.showLoadingOverlay();
    $s.post({
      url: '/cart/update.js',
      type: 'POST',
      url: '/cart/update.js',
      data: {"attributes": {"_discount_code": this.input.value.toUpperCase()}},
      dataType: 'json',
      success: async function(cart) {
        var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);

        if(window.SideCart){
          window.SideCart.updateSideCart(true)
        } else if (window.CartPage) {
          window.CartPage.updateCart();
        } else {
          location = '/cart'
        }

      }
    })
  }
}
customElements.define('cart-discount-code', CartDiscountCode);class AddToCartForm extends HTMLElement {
  constructor() {
    super();
    this.querySelector('form').addEventListener('submit', (e)=>{
      e.preventDefault();
      $s.showLoadingOverlay();
      this.trackATC();
      $s.post({
        url: '/cart/add.js',
        data: new FormData(e.target),
        success: function(){
          $s.addToCartSuccess();
          setTimeout(() => {
            if (window.SideCart) {
              if (typeof pintrk !== 'undefined') {
                var eci_products = [];
                window.cart_json.items.forEach((it) => {
                  eci_products.push({
                    product_id: it.id,
                    product_name: it.product_title,
                    product_category: it.product_type,
                    product_price: it.price,
                    product_quantity: it.quantity
                  });
                });
                pintrk('track', 'AddToCart', {
                    event_id: 'AddToCart',
                    line_items: eci_products,
                    value: window.cart_json.total_price,
                    order_quantity: window.cart_json.item_count,
                    currency: 'USD'
                });
              }
            }
          }, 3000);
          if(window.modal && window.modal.modal) {
            window.modal.close();
          }
        },
        error: function(repsonse){
          $s.addToCartFail(repsonse.description);
        }
      })
    });
  }
  trackATC() {
    var elTrackingData = document.getElementById('atc-tracking');
    if (elTrackingData) {
      var productId = elTrackingData.dataset.productId;
      var productType = elTrackingData.dataset.productType;
      var variants = elTrackingData.children;
      var elSelectedVariant = document.querySelector('add-to-cart-form [data-variant-id=true]');
      if (elSelectedVariant) {
        var variantId = elSelectedVariant.value;
        var elSelectedVariantData = Array.from(variants).find(v => v.dataset.variantId == variantId);
        if (elSelectedVariantData) {
          var trackVariantId = elSelectedVariantData.dataset.variantId;
          var trackVariantPrice = parseInt(elSelectedVariantData.dataset.variantPrice) / 100;
          var trackContentType = productType;
          var trackProductId = productId;

          var trackingData = {
            value: trackVariantPrice,
            currency: 'USD',
            content_ids: trackProductId,
            content_type: trackContentType
          }   
          if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToCart', trackingData);
          }
        }
      }
    }
  }
}
customElements.define('add-to-cart-form', AddToCartForm);

class SelectPlan extends HTMLElement {
  constructor() {
    super();
    this.item = this.dataset.item;
    this.select = this.querySelector('select')
    this.selectedPlanId = this.dataset.selectedPlanId;
    this.selectedPlanName = this.dataset.selectedPlanName;
    this.planCheckbox = this.querySelector('[type=checkbox]');
    this.getPlanValues();
    
  }  

  getPlanValues(){   

    getCartPlans(this);

    this.planCheckbox.checked ? displayText(this, true) : displayText(this, false);

    checkboxUpdate(this);
    selectUpdate(this);

    function checkboxUpdate(selector){
      var checkbox = selector.querySelector('[type=checkbox]');

      checkbox.addEventListener('change', (e) => { 
        var parent = e.target.closest('select-plan');
        var item = parent.closest('.item');
        var select = parent.querySelector('select');
        var cartItem = null;
  
        if (e.target.checked) { 
          getCartPlans(parent);       
          displayText(parent, true);        
          cartItem = { id: `${parent.dataset.item}`, quantity: `${item.querySelector('.quantity-input').value}`, selling_plan: `${select.options[select.selectedIndex].value}` };
          updatePlan(cartItem);
        } else {
          displayText(parent, false)
          cartItem = { id: `${parent.dataset.item}`, quantity: `${item.querySelector('.quantity-input').value}`, selling_plan: '' };
          updatePlan(cartItem);
        }
  
      })
    }

    function selectUpdate(selector){
      var select = selector.querySelector('select');
      select.addEventListener('change', (e) =>{        
        var thisSelect = e.target;
        var selectParent = e.target.closest('select-plan');
        var selectItem = selectParent.closest('.item');
        var selectCartItem = { id: `${selectParent.dataset.item}`, quantity: `${selectItem.querySelector('.quantity-input').value}`, selling_plan: `${thisSelect.options[thisSelect.selectedIndex].value}` };
        thisSelect.style.color = 'transparent';
        updatePlan(selectCartItem);
      })
    }    

    function displayText(selector, plan) {
      if (plan) {
        selector.querySelector('select') ? selector.querySelector('select').style.display = 'block' : '';
        selector.querySelector('.plan-1') ? selector.querySelector('.plan-1').style.display = 'block' : '';
        selector.querySelector('.plan-0') ? selector.querySelector('.plan-0').style.display = 'none' : '';
      } else {
        selector.querySelector('select') ? selector.querySelector('select').style.display = 'none' : '' ;      
        selector.querySelector('.plan-0') ? selector.querySelector('.plan-0').style.display = 'block' : '' ;
        selector.querySelector('.plan-1') ? selector.querySelector('.plan-1').style.display = 'none' : ''
      }
    }

    function getCartPlans(selector) {
      var thisItem = selector.dataset.item;
      var thisSelect = selector.querySelector('select');
      $s.getJson({url: '/cart.json', success: (data) => {
        data.items.forEach((item) => {
          if (thisItem == item.key && item.selling_plan_allocation) {
            thisSelect.value = item.selling_plan_allocation.selling_plan.id;
            thisSelect.style.color = '#000000'
              }  
            })
          }                
      });      
    }

    function updatePlan(cartItem) { 
      if (window.SideCart) {
        window.SideCart.postChange(cartItem);
      } else if (window.CartPage){
        window.CartPage.postChange(cartItem);
      } 
    }
  }  
}
customElements.define('select-plan', SelectPlan);
  var okeReviews = document.querySelectorAll('[data-oke-reviews-product-listing-rating]')
  document.addEventListener('DOMContentLoaded', ()=>{
    okeReviews.forEach(r=>{
      if(r.hasAttribute('data-short-text')) {
        r.style.opacity = 0
      }
    })
  })
  window.addEventListener('load', ()=>{
    okeReviews.forEach(r=>{
      if(r.hasAttribute('data-short-text') && r.querySelector('.okeReviews-reviewsSummary-ratingCount')) {
        var reviewText = r.querySelector('.okeReviews-reviewsSummary-ratingCount span:first-child');
        reviewText.innerHTML= '('+reviewText.innerHTML.split(" ")[0]+')'
        r.style.opacity = 1
      }
    })
  })
//Event to listen cart changes
  document.addEventListener('DOMContentLoaded', function() {
    const cartEndpoint = '/cart.js';

    async function fetchCart() {
        try {
            const response = await fetch(cartEndpoint);
            const cart = await response.json();
            return cart;
        } catch (error) {
            console.error('Failed to fetch cart:', error);
        }
    }

    function triggerCartChangeEvent(cart) {
        const event = new CustomEvent('shopifyCartChanged', { detail: cart });
        document.dispatchEvent(event);
    }

    document.addEventListener('click', async function(e) {
        if (e.target.matches('.add, .remove, .minus, .plus, .cart-count, add-to-cart-form [type="submit"]')) {
            // Wait for the cart to be updated
            setTimeout(async () => {
                const cart = await fetchCart();
                triggerCartChangeEvent(cart);
            }, 1000); // Adjust timeout as necessary based on your cart update delay
        }
    });
    document.addEventListener('change', async function(e) {
        if (e.target.matches('quantity-input input')) {
            // Wait for the cart to be updated
            setTimeout(async () => {
                const cart = await fetchCart();
                triggerCartChangeEvent(cart);
            }, 1000); // Adjust timeout as necessary based on your cart update delay
        }
    });
  });

  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Function to get the current cart contents
    function getCartContents() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => cart);
    }

    // Function to count the number of items in the cart excluding promo items
    function countNonPromoItems(cart) {
        return cart.items.reduce((count, item) => {
            if (!(item.properties && item.properties._promo && item.final_price === 0)) {
                count += item.quantity;
            }
            return count;
        }, 0);
    }

    // Function to enforce the 25-item limit on cart change
    function enforceCartLimit() {
        getCartContents().then(cart => {
            const nonPromoItemCount = countNonPromoItems(cart);
            if (nonPromoItemCount > 25) {
                console.log('You cannot have more than 25 items in the cart.');
                // Remove the last item added to the cart
                const lastItem = cart.items.find(item => !(item.properties && item.properties._promo && item.final_price === 0 && !item.properties._bundle_id));
                if (lastItem) {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: lastItem.key,
                            quantity: 0
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log('Last item removed from cart:', data);
                        // Trigger the custom event to notify that the cart has changed
                        if (window.SideCart) {
                          window.SideCart.updateSideCart(window.SideCart.isOpen());
                        } else if (window.CartPage) {
                          window.CartPage.updateCart();
                        }
                        setTimeout(() => {                            
                          $s.openModal('<div class="error-itemincart">You can only order a maximum of 25 items. The last item added has been removed.</div>') 
                        }, 500);
                        if(!(window.modal && window.modal.modal)){
                        }
                    })
                    .catch(error => {
                        console.error('Error removing last item from cart:', error);
                    });
                }
            }
        });
    }

    // Attach the enforceCartLimit function to the shopifyCartChanged event
    document.addEventListener('shopifyCartChanged', enforceCartLimit);

    // Initial check on page load
    enforceCartLimit();
});
